// import { CommonController } from './controller/CommonController';
import { SubpageController } from './controller/SubpageController';
import { HomeController } from './controller/HomeController';

// ページのカテゴリーでコントローラーを切り替え
const name = document.body.dataset.pageName;

if (name === 'home') {
  new HomeController();
} else {
  new SubpageController();
}

document.body.classList.add('is-dom-loaded');

window.addEventListener('load', () => {
  document.body.classList.add('is-load-end');
  document.body.classList.remove('is-pre-load');

  setTimeout(() => {
    document.body.classList.add('is-load-lag');
  }, 1000);
});
